import { TaskPointsBadge } from '.';

const NumericQuestionAnswer = ({ maxScore, score, answer }) => (
  <div className="answer">
    <div className="content">{answer}</div>

    <TaskPointsBadge maxPoints={maxScore} points={score} />

    <style jsx>{`
      .content {
        background-color: white;
        border-radius: 5px;
        display: inline-block;
        min-width: 60px;
        padding: 5px 10px;
      }
    `}</style>
  </div>
);

export default NumericQuestionAnswer;
